/**
 * 测量标注 overlay 渲染层级常量。
 *
 * 分层约定（`transparent=true + depthTest=false + depthWrite=false` 的 overlay 语义）：
 * 1. 测量线必须与测量选中外观处于同一透明渲染通道，renderOrder 才能生效；
 * 2. 基值 8200 高于草图缩放手柄（8100）及常规交互 overlay；
 * 3. 锚点精灵先于测量线段绘制；
 * 4. 测量线段置于最顶层，避免被其它不写深度的材质后绘制覆盖。
 */

/** 测量标注 overlay 渲染层级基值。 */
export const MEASURE_OVERLAY_RENDER_ORDER_BASE = 8200;

/** 测量拾取锚点精灵渲染层级。 */
export const MEASURE_ANCHOR_MARKER_RENDER_ORDER = MEASURE_OVERLAY_RENDER_ORDER_BASE;

/**
 * 垂直距离线段渲染层级。
 *
 * 位于锚点之上、分量线之下，保证黑线与垂线均可见且层次清晰。
 */
export const MEASURE_NORMAL_DISTANCE_LINE_RENDER_ORDER = MEASURE_OVERLAY_RENDER_ORDER_BASE + 50;

/**
 * 测量 ΔX / ΔY / ΔZ 及直线距离线段渲染层级。
 *
 * 必须高于所有其它 `depthWrite=false` 的 overlay（含测量锚点），保证测量线最后绘制且始终可见。
 */
export const MEASURE_DX_DY_DZ_LINE_RENDER_ORDER = MEASURE_OVERLAY_RENDER_ORDER_BASE + 100;
